/**
 * Whether a page's release date is still ahead. Until then it is not served publicly, may only be
 * viewed behind login or a share code, and its banner names the date it goes live.
 */
export const isUpcomingRelease = (releasedAt: string | undefined, now: Date = new Date()): boolean => {
  if (!releasedAt) {
    return false;
  }
  const releaseTime = new Date(releasedAt).getTime();
  return !Number.isNaN(releaseTime) && releaseTime > now.getTime();
};
